import { createFileRoute } from "@tanstack/react-router";

import { StaffPage } from "../../../features/staff/staff-page";

export const Route = createFileRoute("/_app/settings/staff")({ component: StaffPage });
